<template>
  <div class="news-detail">
    <el-card v-if="item">
      <div class="detail-header">
        <h1>{{ item.title }}</h1>
      </div>
      <div class="detail-meta">
        <span>分类: {{ item.category.name }}</span>
        <span>浏览: {{ item.view_count }}</span>
        <span>发布时间: {{ formatDate(item.created_at) }}</span>
      </div>
      <div v-if="item.cover_image_url" class="detail-image">
        <img :src="item.cover_image_url" alt="封面" />
      </div>
      <div class="detail-content" v-html="formatContent(item.content)"></div>
      <div class="detail-actions">
        <el-button @click="$router.back()">返回</el-button>
      </div>
    </el-card>
    <el-skeleton v-else :rows="10" animated />
  </div>
</template>

<script>
import api from '../api'
import { marked } from 'marked'

export default {
  name: 'NewsDetail',
  data() {
    return {
      item: null
    }
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    async loadDetail() {
      try {
        const id = this.$route.params.id
        const response = await api.get(`/news/items/${id}/`)
        this.item = response.data
      } catch (error) {
        this.$message.error('加载详情失败')
        this.$router.back()
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    },
    formatContent(content) {
      if (!content) return ''
      try {
        return marked(content)
      } catch (e) {
        return content.replace(/\n/g, '<br>')
      }
    }
  }
}
</script>

<style scoped>
.news-detail {
  max-width: 900px;
  margin: 0 auto;
}

.detail-header {
  margin-bottom: 20px;
}

.detail-header h1 {
  margin: 0;
}

.detail-meta {
  margin-bottom: 20px;
  color: #909399;
  font-size: 14px;
}

.detail-meta span {
  margin-right: 20px;
}

.detail-image {
  margin-bottom: 20px;
}

.detail-image img {
  width: 100%;
  max-height: 400px;
  object-fit: cover;
  border-radius: 4px;
}

.detail-content {
  margin-bottom: 30px;
  line-height: 1.8;
  color: #606266;
}

.detail-content :deep(h1),
.detail-content :deep(h2),
.detail-content :deep(h3) {
  margin-top: 20px;
  margin-bottom: 10px;
}

.detail-content :deep(p) {
  margin-bottom: 10px;
}

.detail-content :deep(img) {
  max-width: 100%;
  height: auto;
}

.detail-actions {
  display: flex;
  gap: 10px;
}
</style>

